import React from 'react';

import { TitlePreset } from '@lux/title';
import { Translate } from '@pegasus/translation';

import * as S from './styles';

interface TitleProps {
    isSingleCategory: boolean;
    firstCategoryName?: string;
}

export const Title: React.FC<TitleProps> = ({ isSingleCategory, firstCategoryName }) => {
    const message = isSingleCategory ? 'singleCategoryHeader' : 'titleMultipleCategories';
    const params =
        isSingleCategory && firstCategoryName ? { category: firstCategoryName } : undefined;

    return (
        <S.StyledTitle id="continue-shopping-title" preset={TitlePreset.XS}>
            <Translate message={message} params={params} />
        </S.StyledTitle>
    );
};
